module.exports = __webpack_public_path__ + "img/replace.8a889207.svg";